import config from '../config';

let soundManager;
let dataManager;

class Continue extends Phaser.Scene {
  init (data) {
    let g = this;

    g.transitionActive = true;
    soundManager = g.scene.get('SoundManager');
    soundManager.playMusic('loop-end');
    dataManager = g.sys.game.dataManager;
    dataManager.saveCoins();

    dataManager.setSessionItem('continueAvailable', false);

    g.scene.pause(dataManager.getSessionItem(config.BASE_SCENE));
  }
  create () {
    let g = this;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      console.log('On Continue Resume!');
      soundManager.resumeMusic();
    });

    let bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'overlay-bg');
    bg.setAlpha(0);

    let group = [];
    let panelX = -config.WIDTH / 2;

    let panel = g.add.sprite(panelX, config.CENTER_Y + 172, 'continue-sprite');
    panel.setFrame('window.png');
    group.push(panel);

    let wing = g.add.sprite(panelX, panel.y - 430, 'continue-wing');
    group.push(wing);

    let body = g.add.sprite(panelX, panel.y - 430, 'continue-sprite', 'body.png');
    group.push(body);

    let head = g.add.sprite(panelX, panel.y - 430, 'continue-head');
    group.push(head);

    function repeatAnimationCall () {
      wing.play('continue-wing');
      head.play('continue-head');
      g.time.delayedCall(5000, repeatAnimationCall);
    }
    repeatAnimationCall();

    let textContinue = g.add.sprite(panelX, panel.y - 620, 'continue-sprite');
    textContinue.setFrame('text-continue.png');
    group.push(textContinue);

    let coin = g.add.sprite(panelX + 16, panel.y - 180, 'continue-sprite');
    coin.setFrame('coin.png');
    coin.setOrigin(1, 0.5);
    group.push(coin);

    let coinValue = dataManager.getCoins();
    let coinCount = g.add.bitmapText(panelX + 8, coin.y, 'LondrinaSolid59_Yellow_BorderWhite', g.game.localisationManager.language != "ar" ? coinValue.toLocaleString(g.game.localisationManager.language) : coinValue, 59, 1);
    coinCount.setOrigin(0, 0.5);
    group.push(coinCount);

    let btnContinue = g.add.sprite(panelX, panel.y - 60, 'continue-sprite');
    btnContinue.setFrame('btn-continue.png');
    group.push(btnContinue);
    if (coinValue >= 200) {
      btnContinue.setInteractive();
      btnContinue.on('pointerdown', () => {
        if (g.transitionActive) { return; }
        g.transitionActive = true;
        g.tweens.add({
          targets: bg,
          alpha: 0,
          duration: 250
        });
        g.tweens.add({
          targets: group,
          x: '+=' + config.WIDTH,
          duration: 250,
          ease: 'Quad.easeOut',
          onComplete: () => {
            soundManager.playSound('btn-play');
            dataManager.setCoins(coinValue - 200);
            g.scene.stop('Continue');
            g.scene.stop('Play');
            g.scene.start('Play', { isContinue: true, queuedPause: false, queuedPowerUp: config.BOOSTER });
          }
        });
      });
    } else {
      btnContinue.setAlpha(0.25);
    }

    let btnWatch = g.add.sprite(panelX, panel.y + 85, 'continue-sprite');
    btnWatch.setFrame('btn-watch.png');
    btnWatch.setInteractive();
    btnWatch.on('pointerdown', () => {
      if (g.transitionActive) { return; }
      g.transitionActive = true;
      apiManager.showAd().then(() => {
        g.tweens.add({
          targets: bg,
          alpha: 0,
          duration: 250
        });
        g.tweens.add({
          targets: group,
          x: '+=' + config.WIDTH,
          duration: 250,
          ease: 'Quad.easeOut',
          onComplete: () => {
            console.log('TODO: Show Ad (Pause game after ad has finished)');
            g.scene.stop('Continue');
            g.scene.stop('Play');
            g.scene.start('Play', { isContinue: true, queuedPause: true, queuedPowerUp: config.BOOSTER });
          }
        });
      });
    });
    group.push(btnWatch);

    let btnX = g.add.sprite(panelX, panel.y + 260, 'continue-sprite');
    btnX.setFrame('btn-x.png');
    btnX.setInteractive();
    btnX.on('pointerdown', () => {
      if (g.transitionActive) { return; }
      soundManager.playSound('btn-regular');
      g.transitionActive = true;
      g.tweens.add({
        targets: group,
        x: '+=' + config.WIDTH,
        duration: 250,
        ease: 'Quad.easeOut',
        onComplete: () => {
          g.scene.stop('Continue');
          g.scene.launch('Score', { fadeBg: false });
        }
      });
    });
    group.push(btnX);

    let x2Top = g.add.sprite(btnContinue.x + 190, btnContinue.y, 'continue-sprite', 'x2.png');
    x2Top.setScale(0.5);
    group.push(x2Top);
    if (btnContinue.alpha < 1) {
      x2Top.setAlpha(0);
    }

    let x2Bottom = g.add.sprite(btnWatch.x + 190, btnWatch.y, 'continue-sprite', 'x2.png');
    x2Bottom.setScale(1);
    group.push(x2Bottom);

    g.tweens.add({
      targets: bg,
      alpha: 0.9,
      duration: 250
    });
    g.tweens.add({
      targets: group,
      x: '+=' + config.WIDTH,
      duration: 500,
      ease: 'Back.easeOut',
      onComplete: () => {
        g.transitionActive = false;
        if (btnContinue.alpha === 1) {
          g.tweens.add({
            targets: x2Top,
            scaleX: 1,
            scaleY: 1,
            repeat: -1,
            yoyo: true,
            ease: 'Quad.easeInOut',
            duration: 1000
          });
        }
        g.tweens.add({
          targets: x2Bottom,
          scaleX: 0.5,
          scaleY: 0.5,
          repeat: -1,
          yoyo: true,
          ease: 'Quad.easeInOut',
          duration: 1000
        });
        // temp
        // g.time.delayedCall(500, () => {
        //   g.transitionActive = true;
        //   g.tweens.add({
        //     targets: group,
        //     x: '+=' + config.WIDTH,
        //     duration: 250,
        //     ease: 'Quad.easeOut',
        //     onComplete: () => {
        //       g.scene.stop('Continue');
        //       g.scene.launch('Score');
        //     }
        //   });
        // });
        // end temp
      }
    });
  }
}

export default Continue;
